import { Component, computed, effect, ElementRef, inject, viewChild } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';

import { TranslocoDirective } from '@jsverse/transloco';

import { ChrComponentsModule } from '@ciphr-design-system/angular';

import { AppBrandingService } from '@ciphr/core/app-branding';
import { NavigationStore } from '@ciphr/core/navigation';

import { PageHeaderService } from './page-header-service';

const FOCUS_RESTORE_DELAY_MS = 150;

@Component({
    selector: 'ciphr-page-header',
    imports: [TranslocoDirective, ChrComponentsModule, RouterLink, NgTemplateOutlet],
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
  private readonly brandingService = inject(AppBrandingService);
  private readonly navigationStore = inject(NavigationStore, { optional: true });
  private readonly pageHeaderService = inject(PageHeaderService);

  private readonly navButton = viewChild<ElementRef<HTMLElement>>('navButton');

  readonly actionsTemplates = this.pageHeaderService.actionsTemplates;
  readonly logo = this.brandingService.brandingLogo;
  readonly menuButtonVisible = !!this.navigationStore;
  readonly titleTemplate = this.pageHeaderService.titleTemplate;
  readonly navigationExpanded = computed(() => !!this.navigationStore && !this.navigationStore.hiddenOnHandset());

  private wasExpanded = false;

  constructor() {
    effect(() => {
      const expanded = this.navigationExpanded();
      const collapsing = !expanded && this.wasExpanded;

      this.wasExpanded = expanded;

      if (!collapsing) {
        return;
      }

      setTimeout(() => this.navButton()?.nativeElement.focus(), FOCUS_RESTORE_DELAY_MS);
    });
  }

  toggleAppNavigation(): void {
    this.navigationStore?.toggleVisibility();
  }
}
